export const COURSE_LOCK_DATE = 'course-lock-date'
export const PREV_EXAM_DUE_DATE = 'prev-exam-due-date'
export const BEFORE_EXAM_START_DATE = 'before-exam-start-date'
export const AFTER_EXAM_DUE_DATE = 'after-exam-due-date'
export const PREV_EXAM_START_DATE = 'prev-exam-start-date'
export const NO_ASSESSMENTS = 'no-assessments'
export const PRACTICE_EXAM_AFTER_END_DATE = 'practice-exam-after-end-date'
export const STUDENT_STATUS_WITHDRAW = 'student-status-withdraw'
